import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { length } from 'redux-form-validators';
import { toArray, toPlainObject } from 'lodash';

import {
    NAME_LENGTH,
    FIRSTNAME_LENGTH,
    ADDRESS_LENGTH,
    POSTCODE_LENGTH,
    CITY_LENGTH
} from '../../../../../constants/form';
import { STATIC_ASSOCIATION_LOGO_ROOT, STATIC_ROOT } from '../../../../../constants';
import { PAYMENT_REQUEST_TYPE_ASSOCIATION } from '../../../../../services/account/paymentrequest/request/constants';

import {
    sendPaymentRequest,
    reset,
    setTimeoutId
} from '../../../../../services/account/paymentrequest/request/actions';
import { fetchAssociationsIfNeeded } from '../../../../../services/association/actions';

import { getValidatedAmount } from '../../../../../services/account/gains/selector';
import { getOnGoingPaidAmount } from '../../../../../services/account/paymentrequest/ongoing/selector';
import * as paymentRequestSelector from '../../../../../services/account/paymentrequest/request/selector';

import { formatAmountCurrency, truncateAmount } from '../../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import {
    FormComponent,
    NumberInputFieldComponent,
    LegendFieldComponent,
    TextInputFieldComponent,
    EmailInputFieldComponent,
    RadioInputFieldComponent,
    SelectFieldComponent
} from '../../../../form';
import SvgComponent from '../../../../SvgComponent';
import ButtonComponent from '../../../../button/ButtonComponent';
import { LoadingComponent } from '../../../../loading/LoadingComponent';

import './PaymentRequestFormComponent.scss';

const FORM_NAME = 'paymentrequest-form-association';

class PaymentRequestAssociationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTaxReceiptForm: false
        };
    }

    componentDidMount() {
        this.props.fetchAssociationsIfNeeded();
        this.scrollTop();
    }

    scrollTop = () => {
        if (document.getElementById('paymentAreaAnchor')) {
            document.getElementById('paymentAreaAnchor').scrollIntoView({ behavior: 'smooth' });
        }
    };

    submit = formData => {
        const { sendPaymentRequest, reset, timeoutId, setTimeoutId } = this.props;
        const { showTaxReceiptForm } = this.state;

        clearTimeout(timeoutId);

        let body = formData;
        if (!showTaxReceiptForm) {
            body = {
                associationId: formData.associationId,
                requestedAmount: formData.requestedAmount
            };
        }

        sendPaymentRequest(PAYMENT_REQUEST_TYPE_ASSOCIATION, body, () => {
            const id = setTimeout(() => {
                reset();
            }, 20000);
            setTimeoutId(id);

            this.scrollTop();
        });
    };

    handleClickButtonYes = () => {
        this.setState({
            showTaxReceiptForm: true
        });
    };
    handleClickButtonNo = () => {
        this.setState({
            showTaxReceiptForm: false
        });
    };

    getCountries = () => {
        const { i18nForm } = this.props;

        return [{ label: i18nForm.COUNTRIES.FRANCE.label, value: i18nForm.COUNTRIES.FRANCE.value }];
    };

    populate = () => {
        const { associations } = this.props;

        return associations
            ? toArray(
                  associations
                      .filter(association => association.id === 1) // Filtrer les associations par ID
                      .map((association, i) => ({
                          label: (
                              <div className="association" key={i}>
                                  <img
                                      src={`${STATIC_ASSOCIATION_LOGO_ROOT}/${association.visual}`}
                                      width="120"
                                      height="120"
                                      alt=""
                                  />
                                  <div className="text">
                                      <p className="label">{association.label}</p>
                                      {convertHtmlToReactDomWithParams(association.description)}
                                  </div>
                              </div>
                          ),
                          value: association.id
                      }))
              )
            : [];
    };

    render() {
        const {
            i18n,
            i18nCommon,
            i18nForm,
            requestSubmit,
            errorSubmit,
            errorMessage,
            validatedCashbackAmount,
            paymentRequestTotalAmount,
            requestedAmount,
            initialValues,
            associationFetching
        } = this.props;
        const { showTaxReceiptForm } = this.state;

        const validatedMinusPaymentRequest = truncateAmount(
            validatedCashbackAmount - paymentRequestTotalAmount
        );
        const remainingJackpotAfterPayment =
            validatedMinusPaymentRequest - requestedAmount < 0
                ? 0
                : validatedMinusPaymentRequest - requestedAmount;

        return (
            <div className="payment-request">
                <p className="resume">{i18n.CHOOSE_ASSOCIATION}</p>

                <FormComponent
                    form={FORM_NAME}
                    initialValues={initialValues}
                    classNameInputContainer="payment-request-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.PAYMENT_REQUEST_BUTTON_DON}>
                    <React.Fragment>
                        {associationFetching ? (
                            <LoadingComponent />
                        ) : (
                            <RadioInputFieldComponent
                                name="associationId"
                                classNameInputContainer="association-container"
                                options={this.populate()}
                                isRequired
                                i18nFeatureForm={i18nForm}
                            />
                        )}
                    </React.Fragment>

                    <NumberInputFieldComponent
                        name="requestedAmount"
                        label={i18n.AMOUNT_PAID_TO_ASSOCIATION}
                        placeholder={i18n.EXAMPLE_AMOUNT}
                        classNameInputContainer="amount"
                        min={0.1}
                        max={validatedMinusPaymentRequest}
                        isRequired
                        hideRequired
                        isEuro
                        showSymbol={'€'}
                    />
                    <React.Fragment>
                        <div className="information-div">
                            <span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/info.svg`}
                                    width="20"
                                    height="20"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </span>
                            <span>
                                {convertHtmlToReactDomWithParams(
                                    i18nCommon.REMAINING_JACKPOT_AFTER_PAYMENT_INDICATION,
                                    formatAmountCurrency(remainingJackpotAfterPayment)
                                )}
                            </span>
                        </div>
                    </React.Fragment>

                    <React.Fragment>
                        <p>{i18n.WANT_TAX_RECEIPT}</p>
                        <div className="container-button-recu-fiscal">
                            <ButtonComponent
                                text={i18n.YES}
                                color="main"
                                cssClass={`yes ${!showTaxReceiptForm ? 'reverse' : ''}`}
                                onClick={this.handleClickButtonYes}
                            />
                            <ButtonComponent
                                text={i18n.NO}
                                color="main"
                                cssClass={`no ${showTaxReceiptForm ? 'reverse' : ''}`}
                                onClick={this.handleClickButtonNo}
                            />
                        </div>
                        {showTaxReceiptForm && (
                            <p className="information-transfered">
                                {i18n.CONTACT_INFORMATION_TRANSFERED}
                            </p>
                        )}
                    </React.Fragment>

                    <React.Fragment>
                        {showTaxReceiptForm && (
                            <div className="grid-2 has-gutter full textReceiptForm">
                                <TextInputFieldComponent
                                    name="lastname"
                                    label={i18nForm.LABEL_LASTNAME}
                                    placeholder={i18nForm.LABEL_LASTNAME}
                                    classNameInputContainer="one-half"
                                    validate={[
                                        length({
                                            max: NAME_LENGTH,
                                            msg: i18nForm.LASTNAME_SIZE_ERROR
                                        })
                                    ]}
                                    isRequired
                                    i18nFeatureForm={i18nForm}
                                />
                                <TextInputFieldComponent
                                    name="firstname"
                                    label={i18nForm.LABEL_FIRSTNAME}
                                    placeholder={i18nForm.LABEL_FIRSTNAME}
                                    classNameInputContainer="one-half"
                                    validate={[
                                        length({
                                            max: FIRSTNAME_LENGTH,
                                            msg: i18nForm.FIRSTNAME_SIZE_ERROR
                                        })
                                    ]}
                                    isRequired
                                    i18nFeatureForm={i18nForm}
                                />
                                <EmailInputFieldComponent
                                    name="email"
                                    label={i18nForm.LABEL_EMAIL}
                                    placeholder={i18nForm.LABEL_EMAIL}
                                    classNameInputContainer="mr50"
                                    isRequired
                                    i18nFeatureForm={i18nForm}
                                />
                                <TextInputFieldComponent
                                    name="address"
                                    classNameInputContainer="one-half"
                                    placeholder={i18nForm.LABEL_ADDRESS}
                                    label={i18nForm.LABEL_ADDRESS}
                                    isRequired
                                    i18nFeatureForm={i18nForm}
                                    validate={[
                                        length({
                                            max: ADDRESS_LENGTH,
                                            msg: format(i18nForm.ADDRESS_SIZE_ERROR, ADDRESS_LENGTH)
                                        })
                                    ]}
                                />
                                <TextInputFieldComponent
                                    name="zipcode"
                                    classNameInputContainer="one-half"
                                    placeholder={i18nForm.LABEL_ZIPCODE}
                                    label={i18nForm.LABEL_ZIPCODE}
                                    maxLength={POSTCODE_LENGTH}
                                    isRequired
                                    i18nFeatureForm={i18nForm}
                                    validate={[
                                        length({
                                            max: POSTCODE_LENGTH,
                                            msg: format(
                                                i18nForm.ZIP_CODE_SIZE_ERROR,
                                                POSTCODE_LENGTH
                                            )
                                        })
                                    ]}
                                />
                                <TextInputFieldComponent
                                    name="city"
                                    classNameInputContainer="one-half"
                                    placeholder={i18nForm.LABEL_CITY}
                                    label={i18nForm.LABEL_CITY}
                                    isRequired
                                    i18nFeatureForm={i18nForm}
                                    validate={[
                                        length({
                                            max: CITY_LENGTH,
                                            msg: format(i18nForm.CITY_SIZE_ERROR, CITY_LENGTH)
                                        })
                                    ]}
                                />
                                <SelectFieldComponent
                                    name="country"
                                    classNameInputContainer="one-half"
                                    label={i18nForm.LABEL_COUNTRY}
                                    defaultOptionLabel={i18nForm.LABEL_COUNTRY}
                                    options={this.getCountries()}
                                    i18nFeatureForm={i18nForm}
                                    isRequired
                                />
                            </div>
                        )}
                    </React.Fragment>

                    <React.Fragment>
                        {showTaxReceiptForm && <div className="required"></div>}
                    </React.Fragment>
                    <React.Fragment>
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);
    const validatedCashbackAmount = getValidatedAmount(state);
    const paymentRequestTotalAmount = getOnGoingPaidAmount(state);
    const requestedAmount = formValueSelector(FORM_NAME)(state, 'requestedAmount') || 0;

    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_REQUEST_FORM.ASSOCIATION,
        i18nCommon: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_REQUEST_FORM,
        i18nForm: state.i18n.feature.form,
        user: user,
        associations: state.association.associations,
        associationFetching: state.association.fetching,
        requestSubmit: paymentRequestSelector.isRequesting(state),
        errorSubmit: paymentRequestSelector.isError(state),
        errorMessage: paymentRequestSelector.getError(state),
        validatedCashbackAmount: validatedCashbackAmount,
        paymentRequestTotalAmount: paymentRequestTotalAmount,
        requestedAmount: requestedAmount,
        timeoutId: paymentRequestSelector.getTimeoutId(state),
        initialValues: {
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            email: user.email ? user.email : '',
            address: user.address ? user.address : '',
            zipcode: user.postcode ? user.postcode : '',
            city: user.city ? user.city : '',
            country: user.country ? user.country : ''
        }
    };
};

const mapDispatchToProps = {
    fetchAssociationsIfNeeded,
    sendPaymentRequest,
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRequestAssociationComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/payment-requests/PaymentRequestAssociationComponent.js